<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header">Compose Message</h2>

  <div mat-dialog-content class="dialog-content">
    <ngx-spinner type="ball-atom"></ngx-spinner>
    @if (dialogData?.companyName) {
      <div class="company-badge">
        <mat-icon>business</mat-icon>
        <span>{{ dialogData!.companyName }}</span>
      </div>
    }
    <form [formGroup]="composeForm" class="compose-form">

      <!-- Leader role: pick specific same-category recipients and/or send to administrators -->
      @if (userRole === AppUserRole.Leader) {
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Recipients</mat-label>
          <mat-select formControlName="recipientUserIds" multiple>
            @for (recipient of potentialRecipients; track recipient.userId) {
              <mat-option [value]="recipient.userId">{{ recipient.userFullName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <!-- Admin role: select by roles and/or individual users -->
      @if (userRole === AppUserRole.Admin) {
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Recipient Roles</mat-label>
          <mat-select formControlName="recipientRoles" multiple>
            @for (role of roleOptions; track role.value) {
              <mat-option [value]="role.value">{{ role.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Individual Recipients</mat-label>
          <mat-select formControlName="recipientUserIds" multiple>
            @for (recipient of potentialRecipients; track recipient.userId) {
              <mat-option [value]="recipient.userId">{{ recipient.userFullName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title" placeholder="Enter message title">
        @if (composeForm.get('title')?.hasError('required') && composeForm.get('title')?.touched) {
          <mat-error>Title is required</mat-error>
        }
        @if (composeForm.get('title')?.hasError('maxlength')) {
          <mat-error>Title cannot exceed 200 characters</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Message</mat-label>
        <textarea matInput formControlName="messageText" rows="6" placeholder="Type your message here..."></textarea>
        @if (composeForm.get('messageText')?.hasError('required') && composeForm.get('messageText')?.touched) {
          <mat-error>Message is required</mat-error>
        }
        @if (composeForm.get('messageText')?.hasError('maxlength')) {
          <mat-error>Message cannot exceed 5000 characters</mat-error>
        }
      </mat-form-field>

      <!-- User/Leader roles: checkbox to send to administrators -->
      @if (userRole === AppUserRole.User || userRole === AppUserRole.Leader) {
        <mat-checkbox formControlName="isForAdministrator" color="primary">
          Send to administrator
        </mat-checkbox>
      }

      @if (userRole === AppUserRole.Leader && composeForm.hasError('recipientsRequired') && composeForm.touched) {
        <span class="recipients-required-error">Select at least one recipient or send to administrator</span>
      }

      <div class="file-upload-section">
        @if (!selectedFile) {
          <button mat-stroked-button type="button" (click)="fileInput.click()">
            <mat-icon>attach_file</mat-icon>
            Attach File
          </button>
          <input #fileInput type="file" hidden (change)="onFileSelected($event)">
          <span class="file-hint">Max 10MB</span>
        } @else {
          <div class="selected-file">
            <mat-icon>description</mat-icon>
            <span class="file-name">{{ selectedFile.name }}</span>
            <span class="file-size">({{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB)</span>
            <button mat-icon-button type="button" (click)="removeFile()" class="remove-file-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        }
      </div>
    </form>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onCancel()">
      <mat-icon>clear</mat-icon>
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="onSend()" [disabled]="composeForm.invalid">
      <mat-icon>send</mat-icon>
      Send
    </button>
  </div>
</div>
